import { SessionContext } from '@contexts/session-context';
import { Feature } from '@enums/feature.enum';
import { Icon, Radio, RadioGroup, useTranslation } from '@testsigma/atoms';
import React, { useContext } from 'react';

type AppExecuteChoosetype = {
  setRadio: Function;
  radio: string;
};

export const AppExecuteChoose = (props: AppExecuteChoosetype) => {
  const { t } = useTranslation();
  const { session } = useContext(SessionContext);
  return (
    <div className='flex flex-col gap-1.5'>
      <span className='text-xs leading-4 font-semibold text-secondary-500'>
        {t('upload.iosapp.title.execute')}
      </span>
      {session?.uiPreferences?.iosProvisioningProfileEnabled ? (
        <RadioGroup
          onChange={(e: any) => {
            props.setRadio(e.target.value);
          }}
          value={props.radio}
          name='upload-ios'
          className='flex flex-row gap-4 w-full'>
          <Radio
            name='webdriver'
            value='webdriver'
            className={
              'w-1/2 !items-start p-3 rounded-xl border !gap-x-3 ' +
              (props.radio === 'webdriver'
                ? 'bg-primary-50 border-primary-300'
                : 'border-[#e2e7ee] bg-secondary-unique-1000')
            }
            checked={props.radio === 'webdriver'}>
            <span className='text-xs font-semibold leading-4'>
              {t('upload.iosapp.webdriver.title')}
            </span>
            <span className='mt-1 text-xs font-normal leading-4 block text-unique-800'>
              {t('upload.iosapp.webdriver.note')}
            </span>
          </Radio>
          <Radio
            name='provision'
            value='provision'
            className={
              'w-1/2 !items-start p-3 rounded-xl border !gap-x-3 ' +
              (props.radio === 'provision'
                ? 'bg-primary-50 border-primary-300'
                : 'border-[#e2e7ee] bg-secondary-unique-1000')
            }
            checked={props.radio === 'provision'}>
            <span className='text-xs font-semibold leading-4'>
              {t('upload.iosapp.provisioningprofile.title')}
            </span>
            <span className='mt-1 text-xs font-normal leading-4 block text-unique-800'>
              {t('upload.iosapp.provisioningprofile.note')}
            </span>
          </Radio>
        </RadioGroup>
      ) : (
        <Radio
          name='webdriver'
          value='webdriver'
          className={
            'w-1/2 !items-start p-3 rounded-xl border !gap-x-3 ' +
            (props.radio === 'webdriver'
              ? 'bg-primary-50 border-primary-300'
              : 'border-[#e2e7ee] bg-secondary-unique-1000')
          }
          checked={props.radio === 'webdriver'}>
          <span className='text-xs font-semibold leading-4'>
            {t('upload.iosapp.webdriver.title')}
          </span>
          <span className='mt-1 text-xs font-normal leading-4 block text-unique-800'>
            {t('upload.iosapp.webdriver.note')}
          </span>
        </Radio>
      )}
    </div>
  );
};
